import { useEffect } from "react";

import { useState } from "react";
import { PageLoading } from "../../../components/page_loading";
import Grid from "@mui/joy/Grid";
import Typography from "@mui/joy/Typography";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import Input from "@mui/joy/Input";
import FormHelperText from "@mui/joy/FormHelperText";
import Switch from "@mui/joy/Switch";

export const AuthenticationComponent = (props: {
  loading: boolean;
  deploymentId: string;
  authenticationStackParamsJson: string | null;
  authenticationStackStatus: string | null;
}) => {
  const { loading, authenticationStackParamsJson, authenticationStackStatus } =
    props;

  const [allowAdminCreateUserOnly, setAllowAdminCreateUserOnly] =
    useState<boolean>(false);
  const [oidcEnabled, setOidcEnabled] = useState<boolean>(false);
  const [oidcThumbprint, setOidcThumbprint] = useState<string>("");
  const [oidcClientId, setOidcClientId] = useState<string>("");
  const [oidcUrl, setOidcUrl] = useState<string>("");
  const [userPoolEnabled, setUserPoolEnabled] = useState<boolean>(false);
  const [alertsEnabled, setAlertsEnabled] = useState<boolean>(false);

  useEffect(() => {
    if (authenticationStackParamsJson) {
      const params = JSON.parse(authenticationStackParamsJson);
      setAllowAdminCreateUserOnly(params.AllowAdminCreateUserOnly || false);
      setOidcEnabled(params.OidcEnabled || false);
      setOidcThumbprint(params.OidcThumbprint || "");
      setOidcClientId(params.OidcClientId || "");
      setOidcUrl(params.OidcUrl || "");
      setUserPoolEnabled(params.UserPoolEnabled || false);
      setAlertsEnabled(params.AlertsEnabled || false);
    }
  }, [authenticationStackParamsJson]);

  return (
    <>
      <PageLoading loading={loading} />
      <Grid container spacing={2} sx={{ flexGrow: 1 }}>
        <Grid xs={12}>
          <Typography level="body-sm" sx={{ py: 1 }}>
            CloudFormation stack status:{" "}
            {authenticationStackStatus || "Not deployed"}
          </Typography>
        </Grid>
        <Grid xs={12} sm={6}>
          <FormControl>
            <FormLabel>Only Admin Can Invite Users</FormLabel>
            <Typography
              component="label"
              startDecorator={
                <Switch
                  checked={allowAdminCreateUserOnly}
                  onChange={(event) => {
                    setAllowAdminCreateUserOnly(event.target.checked);
                  }}
                />
              }
            >
              {allowAdminCreateUserOnly ? "Enabled" : "Disabled"}
            </Typography>
            <FormHelperText>
              If enabled, only admins can invite users.
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid xs={12} sm={6}>
          <FormControl>
            <FormLabel>OIDC Enabled</FormLabel>
            <Typography
              component="label"
              startDecorator={
                <Switch
                  checked={oidcEnabled}
                  onChange={(event) => {
                    setOidcEnabled(event.target.checked);
                  }}
                />
              }
            >
              {oidcEnabled ? "Enabled" : "Disabled"}
            </Typography>
            <FormHelperText>
              If enabled, OIDC authentication is enabled.
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid xs={12} sm={6}>
          <FormControl>
            <FormLabel>OIDC Thumbprint</FormLabel>
            <Input
              disabled={true}
              type="password"
              slotProps={{
                input: {
                  sx: {
                    WebkitTextSecurity: "disc",
                  },
                },
              }}
              value={oidcThumbprint}
              onChange={(event) => {
                setOidcThumbprint(event.target.value);
              }}
            />
            <FormHelperText>
              The thumbprint of the OIDC provider.
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid xs={12} sm={6}>
          <FormControl>
            <FormLabel>OIDC Client ID</FormLabel>
            <Input
              disabled={true}
              value={oidcClientId}
              onChange={(event) => {
                setOidcClientId(event.target.value);
              }}
            />
            <FormHelperText>The client ID of the OIDC provider.</FormHelperText>
          </FormControl>
        </Grid>
        <Grid xs={12} sm={6}>
          <FormControl>
            <FormLabel>OIDC URL</FormLabel>
            <Input
              disabled={true}
              value={oidcUrl}
              onChange={(event) => {
                setOidcUrl(event.target.value);
              }}
            />
            <FormHelperText>The URL of the OIDC provider.</FormHelperText>
          </FormControl>
        </Grid>
        <Grid xs={12} sm={6}>
          <FormControl>
            <FormLabel>User Pool Enabled</FormLabel>
            <Typography
              component="label"
              startDecorator={
                <Switch
                  checked={userPoolEnabled}
                  onChange={(event) => {
                    setUserPoolEnabled(event.target.checked);
                  }}
                />
              }
            >
              {userPoolEnabled ? "Enabled" : "Disabled"}
            </Typography>
            <FormHelperText>
              If enabled, a Cognito User Pool is created for storing user
              credentials.
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid xs={12} sm={6}>
          <FormControl>
            <FormLabel>Alerts Enabled</FormLabel>
            <Typography
              component="label"
              startDecorator={
                <Switch
                  checked={alertsEnabled}
                  onChange={(event) => {
                    setAlertsEnabled(event.target.checked);
                  }}
                />
              }
            >
              {alertsEnabled ? "Enabled" : "Disabled"}
            </Typography>
            <FormHelperText>
              If enabled, alerts are sent on signups.
            </FormHelperText>
          </FormControl>
        </Grid>
      </Grid>
    </>
  );
};
